// Gallery.jsx
import { Button, ButtonGroup } from "react-bootstrap";
import { header } from "./globalVariables";
import { api } from "./pureFunctions";
import { useDropboxImages } from "./useDropboxImages";
import { useState, useCallback, useEffect } from "react";

import arrowIcon from "./img/arrow.png";
import downloadIcon from "./img/downloadIcon.png";
import { SpinnerGroup } from "./Utils/SpinnerGroup";
import { renameDbxItem } from "./networkFunctions";
import Gallery from "./DropBoxGallery";

const MAX_IMG = 10;
export default function GalleryParent({ selectedImages, setSelectedImages, folderName, setOpenMedia, allowRename }) {
   return (
      <div
         style={{
            position: "fixed",
            top: 0,
            // top: 60,
            left: 0,
            zIndex: 10000000,
            width: "100%",
            height: "calc(100vh - 0px)",
            background: "#000d",
            backdropFilter: "blur(4px)",
         }}
      >
         <div
            className="flex-row"
            style={{
               zIndex: 2,
               borderRadius: 20,
               position: "absolute",
               right: 80,
               top: 30,
               padding: 20,
               background: "#fffa",
               fontFamily: "monospace",
               backdropFilter: "blur(4px) saturate(1.6)",
                  border: "solid 1px #fff4",
            }}
         >
            {/* {setSelectedImages&&selectedImages.length > 0 && (
               <div className="mx-3">
                  <strong style={{ fontSize: 46, color: selectedImages.length >= MAX_IMG ? "#d00" : "#000" }}>
                     {selectedImages.length}
                  </strong>
                  /{MAX_IMG}
               </div>
            )} */}
            
            <button
               className="btn btn-light"
               style={{
                  margin: 0,
                  padding: 0,
                  // padding: "20px 4px",
                  fontSize: 50,
                  fontWeight: 700,
                  height: 80,
                  aspectRatio: 1,
                  // background: "#fffa",
                  color: "#000",
                  backdropFilter: "blur(4px)",
                  // boxShadow: "0 0 10px 2px #0009",
               }}
               onClick={() => {
                  setOpenMedia(false);
               }}
            >
               &times;
            </button>
         </div>
         {setSelectedImages && (
            <div
               style={{
                  background: "#fff9",
                  padding: 20,
                  borderRadius: 20,
                  position: "absolute",
                  bottom: 50,
                  right: 80,
                  zIndex: 1,
                  justifyContent: "center",
                  backdropFilter: "blur(4px) saturate(1.6)",
                  border: "solid 1px #fff4",
               }}
            >
               {setSelectedImages && (
                  <div className="mx-0 text-center">
                     <strong style={{ fontSize: 46, color: "#000" }}>{Object.keys(selectedImages).length}</strong>/
                     {MAX_IMG}
                  </div>
               )}
               <Button
                  onClick={() => {
                     setOpenMedia(false);
                  }}
                  variant="light"
                  style={{}}
               >
                  Auswählen
               </Button>
            </div>
         )}

         <div style={{ display: "flex", flexDirection: "row", height: "100%" }}>
            <Gallery
               selectedImages={selectedImages}
               setSelectedImages={setSelectedImages}
               folderName={folderName}
               width={33}
               cols={1}
               subFolder={"Ogulo Grundriss"}
               allowRename={allowRename}
            />

            <Gallery
               selectedImages={selectedImages}
               setSelectedImages={setSelectedImages}
               folderName={folderName}
               width={66}
               cols={2}
               subFolder={"Bilder"}
               allowRename={allowRename}
            />
         </div>
      </div>
   );
}
